import { initSentry } from '@studio/core/components/ErrorBoundary/sentry';

const closeSentry = await initSentry();

// eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
if (import.meta.webpackHot) {
  import.meta.webpackHot.accept();
  import.meta.webpackHot.dispose(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    closeSentry?.();
  });
}
